import "@@/core/assets/css/print.css";
import { Printd } from "printd";
import styles from "./getStyles";
import configProvider from "@@/core/configProvider";
import { BTable } from "bootstrap-vue";
import VueBarcode from "vue-barcode";
import QRCode from "qrcode";
export default {
  components: {
    BTable,
    VueBarcode,
    QRCode,
  },
  props: {
    order: Object,
    settings: Array,
  },
  configProvider,
  data() {
    return {
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "sku",
          label: "کد انبار",
        },
        {
          key: "product",
          label: "محصول",
        },
        {
          key: "amount",
          label: "قیمت ",
        },
        {
          key: "discount_amount",
          label: "تخفیف",
        },
        {
          key: "quantity",
          label: "تعداد",
        },
        {
          key: "total_price",
          label: "مبلغ کل",
        },
      ],
      qr: "",
    };
  },
  watch: {
    order: {
      immediate: true,
      handler() {
        if (this.order) {
          // this.order.active_items = this.order.items.filter(i => i.status)
          this.order.active_items = this.order.items;
        }
      },
    },
  },
  mounted() {
    this.generateQR(this.order.barcode);
  },
  computed: {
    items() {
      let items = [];
      // this.order.
    },
    invoice() {
      let invoice = this.order.invoices.filter(
        (invoice) => invoice.status == "success",
      );
      if (invoice != "") {
        return invoice[0];
      } else {
        return null;
      }
    },
    invoicePayment() {
      let invoicePayment = this.invoice
        ? this.invoice.payments.filter((payment) => payment.status == "success")
        : [];
      if (invoicePayment != "") {
        return invoicePayment[0];
      } else {
        return null;
      }
    },
    address() {
      return JSON.parse(this.order.address);
    },
    total() {
      return this.order.items
        .filter((i) => i.status)
        .reduce((sum, item) => {
          sum += (item.amount + item.discount_amount) * item.quantity;
          return sum;
        }, 0);
    },
    totalPrice() {
      if (this.order.discount_amount) {
        return (
          this.total + this.order.shipping_amount - this.order.discount_amount
        );
      } else {
        return this.total + this.order.shipping_amount;
      }
    },
    totalDiscount() {
      return this.order.active_items
        .filter((i) => i.status)
        .reduce((sum, item) => {
          sum += item.discount_amount * item.quantity;
          return sum;
        }, 0);
    },
  },
  methods: {
    rowClass(item, type) {
      if (item.status === 0) return "warnignRow";
      if (item.quantity > 1) {
        return "highlight";
      }
    },
    cloneGorgan(settings) {
      let address = settings.filter((item) => item.name == "shop_address")[0]
        .value;
      let findGorgan = address.indexOf("گرگان");
      let findGolestan = address.indexOf("گلستان");

      if (findGorgan != -1) {
        address =
          address.slice(0, findGorgan) +
          "<span class='font-weight-bolder fontsize16'>گرگان </span>" +
          address.slice(findGorgan + 5);
      }
      if (findGolestan != -1) {
        address =
          address.slice(0, findGolestan) +
          "<span class='font-weight-bolder fontsize18 '>گلستان </span>" +
          address.slice(findGolestan + 6);
      }

      return address;
    },
    orderPrint() {
      const d = new Printd();
      const printEl = document.getElementById("print");

      // ۱) همه‌ی <link rel="stylesheet">های صفحه
      const links = Array.from(
        document.querySelectorAll("link[rel='stylesheet']"),
      ).map((link) => link.href);

      // ۲) همه‌ی <style>های تزریقی (مثلاً style-vue یا global webpack)
      const inlineStyles = Array.from(document.querySelectorAll("style")).map(
        (styleTag) => styleTag.innerHTML,
      );

      // ۳) استایل‌های سفارشی شما (از getStyles.js یا getStyles2.js)
      //    دقت کن که کدام‌یک محتوای بوت‌استرپ + print.css + استایل‌های خودت را دارد
      let customStyles = styles; // اگر لازم است فونت @font-face اضافه کن

      // ۴) آرایه‌ی کامل style sources
      const styleSources = [
        ...links, // لینک به CSS خارجی
        ...inlineStyles, // استایل داخل <style>
        customStyles, // رشته‌ی CSS اختصاصی
      ];

      // ۵) چاپ!
      d.print(printEl, styleSources);
    },
    generateQR(text) {
      QRCode.toDataURL(text)
        .then((url) => {
          this.qr = url; // آدرس base64 عکس QR
        })
        .catch((err) => {
          console.error("خطا در ساخت QR:", err);
        });
    },
  },
};
